<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import TextArea from 'dashboard/components-next/textarea/TextArea.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import { MESSAGE_MAX_LENGTH } from 'shared/helpers/MessageTypeHelper';

const props = defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['confirm']);

const { t } = useI18n();

const dialogRef = ref(null);
const content = ref('');

const open = originalContent => {
  content.value = originalContent;
  dialogRef.value?.open();
};

const close = () => {
  dialogRef.value?.close();
};

defineExpose({ open, close });

const onSubmit = () => {
  if (!content.value.trim() || props.isLoading) return;
  emit('confirm', content.value.trim());
};
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('CONVERSATION.CONTEXT_MENU.EDIT_MESSAGE.TITLE')"
    width="lg"
    :show-cancel-button="false"
    :show-confirm-button="false"
  >
    <div class="flex flex-col gap-4">
      <TextArea
        v-model="content"
        :max-length="MESSAGE_MAX_LENGTH.GENERAL"
        show-character-count
        min-height="8rem"
        autofocus
      />
      <div class="flex items-center justify-end gap-3">
        <NextButton
          variant="faded"
          color="slate"
          type="button"
          :disabled="isLoading"
          :label="t('CONVERSATION.CONTEXT_MENU.EDIT_MESSAGE.CANCEL')"
          @click="close"
        />
        <NextButton
          variant="solid"
          color="blue"
          type="button"
          :is-loading="isLoading"
          :disabled="!content.trim() || isLoading"
          :label="t('CONVERSATION.CONTEXT_MENU.EDIT_MESSAGE.SAVE')"
          @click="onSubmit"
        />
      </div>
    </div>
  </Dialog>
</template>
